'use es6';

import { cleanObject } from '../utils/formatters';
import Immutable from 'immutable';
const defaults = {
  versionNumber: 0,
  versionKey: '',
  publishedAt: 0,
  releaseNotes: ''
};
export default class VersionInfo extends Immutable.Record(defaults) {
  constructor(values = {}) {
    super(cleanObject(values));
  }

}